"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseStatus = void 0;
const Network_1 = require("decentraland-ui/dist/components/BuyManaWithFiatModal/Network");
var PurchaseStatus;
(function (PurchaseStatus) {
    PurchaseStatus["PENDING"] = "pending";
    PurchaseStatus["FAILED"] = "failed";
    PurchaseStatus["CANCELLED"] = "cancelled";
    PurchaseStatus["REFUNDED"] = "refunded";
    PurchaseStatus["COMPLETE"] = "complete";
})(PurchaseStatus = exports.PurchaseStatus || (exports.PurchaseStatus = {}));
//# sourceMappingURL=types.js.map